import Axios from "@app/api/axios";
import { GET_ORDER_ITEMS } from "@utils/constant";

const getReportByConsentIdService = (payload = "") => {
  return Axios.get(`${GET_ORDER_ITEMS}?consent_id=${payload}`);
};

export default getReportByConsentIdService;
